"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('weixin-top-stories', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M24 4L31.2 11.5292L41.3205 14L38.4 24L41.3205 34L31.2 36.4708L24 44L16.8 36.4708L6.67949 34L9.6 24L6.67949 14L16.8 11.5292L24 4Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M30.9772 11.9152L31.3718 19.7441L37.9545 24.0002L31.3718 28.2563L30.9772 36.0852L24 32.5125L17.0227 36.0852L16.6282 28.2563L10.0455 24.0002L16.6282 19.7441L17.0227 11.9152L24 15.488L30.9772 11.9152Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;